import React from "react";
import { useDispatch } from "react-redux";
import { saveDonationInfo } from "@slices/donationSlice";
import ReactPixel from "react-facebook-pixel";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useRef, useEffect } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { getUserDetails } from "@api/services/userService";

import Cookies from "js-cookie";

import {
    Box,
    Stepper,
    Step,
    StepLabel,
    Dialog,
    IconButton,
    useMediaQuery,
    useTheme,
    Grid,
    AppBar,
    Toolbar,
    Typography,
    DialogContent,
    Button,
    Hidden,
    Divider,
} from "@mui/material";

import DonorInfoForm from "../DonorInfoForm";

import DonationSuccessPage from "../DonationSuccessful";
import parse from "html-react-parser";
import PaymentMethod from "../PaymentMethod";
import { useAppDispatch, useAppSelector } from "@store/hooks";
import { selectAuth } from "@slices/authSlice";
import { DonationBody } from "@interfaces/Donation";
import { createDonation } from "@api/services/donationService";
import { APICaller, useAPICaller } from "@api/request";
import donorInfoContext from "@utilities/contexts/donorInfoContext";
import selectedOptionsContext from "@utilities/contexts/selectedOptionsContext";
import { NotificationProperties } from "@interfaces/Notification";
import Notification from "@components/Notification";
import { donorInfoFormSchema, donorInfoFormSchemaBkash, donorInfoFormSchemaNagad } from "@schemas/index";
import ShadowedButton from "@components/ShadowedButton";
import { hideLoader, showLoader } from "@slices/loaderSlice";
import { sendEvent } from "@utilities/googleAnalytics";
import { GoogleAnalyticsEvents } from "@constants/googleAnalyticsEvents";
import { handleDonationInitiated } from "@utilities/facebookPixel";
import { API_BASE_URL } from "@api/endPoints";

interface HorizontalLinearStepperProps {
    showDialog: boolean;
    ImageUrl: string;
    description: string;
    title: string;
    onClick: (donateNowClicked: boolean) => void; // Accepts a boolean argument
}

const HorizontalLinearStepper: React.FC<HorizontalLinearStepperProps> = ({ showDialog, ImageUrl, description, title, onClick }) => {
    const dispatch = useAppDispatch();
    const auth = useAppSelector(selectAuth);
    const params = useParams();
    const location = useLocation();
    const theme = useTheme();
    const slug = params.slug;

    const smallerScreens = useMediaQuery(theme.breakpoints.down("sm"));

    const queryParams = new URLSearchParams(location.search);
    const isAccepted = queryParams.get("accept");
    const isStatus = queryParams.get("status");
    const isAmount = queryParams.get("amount");
    const offlineDonation = queryParams.get("offline_donation");
    const APICallerRef = useRef<APICaller>(useAPICaller());

    const [activeStep, setActiveStep] = useState<number>(0);
    const [selectedDeservingCandidates, setSelectedDeservingCandidates] = useState<[]>([]);
    const [donationCurrency, setDonationCurrency] = useState<string>("");
    const [donationAmount, setDonationAmount] = useState<string>("");
    const [donationAmountInBDT, setDonationAmountInBDT] = useState<string>("");
    const [donationType, setDonationType] = useState<string>("");
    const [paymentType, setPaymentType] = useState<string>("");
    const [donationFrequency, setDonationFrequency] = useState<string>("");
    const [isDonationSuccessful, setIsDonationSuccessful] = useState<boolean>(false);
    const [isOfflineDonation, setIsOfflineDonation] = useState<boolean>(false);
    const [donorName, setDonorName] = useState<string>("");
    const [donorEmail, setDonorEmail] = useState<string>("");
    const [donorPhoneNumber, setDonorPhoneNumber] = useState<string>("");
    const [donorAddress, setDonorAddress] = useState<string>("");
    const [donorCity, setDonorCity] = useState<string>("");
    const [donorState, setDonorState] = useState<string>("");
    const [donorCountry, setDonorCountry] = useState<string>("");
    const [donorZipCode, setDonorZipCode] = useState<string>("");
    const [isAnnonymous, setIsannonymous] = useState<boolean>(false);
    const [isAgreed, setIsagreed] = useState<boolean>(false);
    const [isOrganization, setIsOrganization] = useState<boolean>(false);
    const [organizationName, setOrganizationName] = useState<string>("");
    const [notification, setNotification] = useState<NotificationProperties>({ isOpen: false, message: "", type: "success" });
    const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState<boolean>(false);
    const [invalidAmount, setInvalidAmount] = useState<boolean>(false);
    const [selectedPatient, setSelectedPatient] = useState<{ id: number; name: string }>({ id: 0, name: "" });
    const [selectedInstrument, setSelectedInstrument] = useState<{ id: number; name: string }>({ id: 0, name: "" });
    const [selectedResearch, setSelectedResearch] = useState<{ id: number; name: string }>({ id: 0, name: "" });
    const [userDetails, setUserDetails] = useState<any>(null);
    const [initialValues, setInitialValues] = useState({
        email: "",
        phone_number: "",
        name: "",
        address: "",
        city: "",
        state: "",
        zipCode: "",
        country: "Bangladesh",
        isAnnonymous: false,
        isOrganization: false,
        isAgreed: true,
        organizationName: "",
    });

    const utmSessionUuid = Cookies.get("utm_session_uuid");
    let utmData = JSON.parse(Cookies.get("utm_data") || "{}");

    // Exclude 'first_time_visit' and 'utm_session_referrer' from checking
    const filteredKeys = Object.keys(utmData).filter((key) => key !== "first_time_visit" && key !== "utm_session_referrer" && key !== "recent_visit");

    // Check if all filtered keys have null values
    const isUtmDataInvalid = filteredKeys.length > 0 && filteredKeys.every((key) => utmData[key] === null);

    if (isUtmDataInvalid) {
        utmData = null; // Only set utmData to null before sending, without modifying the cookie
    }

    // Now you can send utmData to your backend (e.g., via an API request)

    const { values, handleChange, handleBlur, handleSubmit, errors, touched, validateForm, setErrors } = useFormik({
        initialValues,
        enableReinitialize: true,
        // validationSchema: paymentType == "Bkash" || paymentType == "Nagad" ? donorInfoFormSchemaBkash : donorInfoFormSchema,
        // validationSchema: donorInfoFormSchema,
        validationSchema:
            paymentType === "Bkash" ? donorInfoFormSchemaBkash : paymentType === "Nagad" ? donorInfoFormSchemaNagad : donorInfoFormSchema,

        validateOnChange: true,
        validateOnBlur: false,
        onSubmit: () => {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            console.log(paymentType, "paymentType");
        },
    });

    const stepsContent = [
        <PaymentMethod
            campaignSlug={slug}
            setDonationCurrency={setDonationCurrency}
            setDonationAmount={setDonationAmount}
            setDonationAmountInBDT={setDonationAmountInBDT}
            setDonationType={setDonationType}
            setPaymentType={setPaymentType}
            setDonationFrequency={setDonationFrequency}
            setInvalidAmount={setInvalidAmount}
        ></PaymentMethod>,
        <DonorInfoForm
            values={values}
            handleBlur={handleBlur}
            handleChange={handleChange}
            touched={touched}
            errors={errors}
            payment_type={paymentType}
        />,
    ];
    const stepsLabel = ["Donation Information", "Your Information"];
    let paymentStep = 1;


    useEffect(() => {
        if (showDialog) {
            // Prevent body scroll when modal is open
            document.body.style.overflow = "hidden";
        } else {
            // Re-enable body scroll when modal is closed
            document.body.style.overflow = "auto";
        }

        // Cleanup to reset when component unmounts or modal is closed
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [showDialog]);

    useEffect(() => {
        if (auth.isLoggedIn) {
            getUserData();
        }
    }, [auth.isLoggedIn]);

    useEffect(() => {
        if (userDetails?.email) {
            setInitialValues((prevValues) => ({
                ...prevValues,
                email: userDetails?.email,
                name: userDetails?.name,
                phone_number: userDetails?.phone_number,
                address: userDetails?.address,
                city: userDetails?.city,
                state: userDetails?.state,
                zipCode: userDetails?.zip_code,
                country: userDetails?.country,
                // Update email dynamically
            }));
        }
    }, [userDetails]);

    const getUserData = async () => {
        try {
            if (auth.userInfo?.id) {
                const { data: userDetails } = await getUserDetails(auth.userInfo?.id, APICallerRef.current);
                setUserDetails(userDetails);
            }
        } catch (error: any) {
            console.error("Error fetching user data:", error);
        }
    };

    const handleNext = async () => {
        if (activeStep === paymentStep) {
            await handleSubmit(); // Ensure Formik validation runs

            // Wait for Formik to update the errors state
            const formErrors = await validateForm();

            if (Object.keys(formErrors).length > 0) {
                console.log("Form Errors:", formErrors);
                // Stop if errors exist
                console.log("Validation failed. Fix errors before proceeding.");
                return;
            }

            console.log("Proceeding to payment");

            const basePath = `/${process.env.REACT_APP_BASE_NAME}`;
            const cancel_url = window.location.origin + basePath + location.pathname;
            const return_url = window.location.origin + basePath + location.pathname;

            // Check if UTM session is valid

            saveDonation({
                name: donorName,
                email: donorEmail,
                phone_number: donorPhoneNumber,
                address: donorAddress,
                city: donorCity,
                state: donorState,
                country: donorCountry,
                zip_code: donorZipCode,
                campaign_slug: slug,
                selected_deserving_candidates: selectedDeservingCandidates,
                donation_type: donationType,
                payment_type: paymentType,
                amount: Number(donationAmount),
                amount_in_bdt: Number(donationAmountInBDT),
                currency: donationCurrency.substring(0, 3),
                frequency: donationFrequency,
                cancel_url: cancel_url,
                return_url: return_url,
                isAnnonymous: isAnnonymous,
                isOrganization: isOrganization,
                organizationName: organizationName,
                utm_parameters: utmSessionUuid ? utmData : null, // Send only if session is valid
                utm_session_uuid: utmSessionUuid,
            });

            sendEvent(GoogleAnalyticsEvents.ProceedToPaymentButton);
        } else {
            // dispatch(
            //     saveDonationInfo({
            //         currency: donationCurrency.substring(0, 3),
            //         currency_with_symbol: donationCurrency,
            //         payment_type: paymentType,
            //         amount: Number(donationAmount),
            //         frequency: donationFrequency,
            //         donation_type: donationFrequency === "Monthly" ? "Recurring" : donationType,
            //     })
            // );
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    const trackFacebookPurchaseEvent = async (usdAmount: number) => {
        try {
            // send Purchase event
            const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

            await fetch(`${API_BASE_URL}/facebook/conversion`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    event_name: "Purchase",
                    event_id: "lead_20001",
                    event_source_url: window.location.href,
                    user_data: {
                        name: donorName,
                        email: donorEmail,
                        phone: donorPhoneNumber,
                    },
                    custom_data: {
                        value: usdAmount,
                        currency: "USD",
                        content_type: "donation"
                    }
                })
            });

        } catch (error) {
            console.error("Error fetching campaign data:", error);
        }
    };

    useEffect(() => {
        if (typeof window !== "undefined") {
            const loadFacebookPixel = async () => {

                if (isAccepted || isStatus) {
                    if (isAccepted === "1" || isStatus === "SUCCEEDED") {
                        setIsDonationSuccessful(true);
                        setIsOfflineDonation(offlineDonation === "1" ? true : false);
                        setActiveStep(stepsLabel.length);

                        if (isAmount) {
                            const usdAmount = parseFloat(isAmount) / 120;
                            trackFacebookPurchaseEvent(usdAmount);
                        }
                    } else {
                        setIsDonationSuccessful(false);
                        setActiveStep(stepsLabel.length);
                        console.log(isDonationSuccessful, "isDonationSuccessful");
                    }
                }
            };

            loadFacebookPixel();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAccepted, isStatus, offlineDonation, stepsLabel.length]);

    const handleBack = () => {
        if (activeStep === 0) {
            onClick(false);
        } else if (activeStep === stepsLabel.length) {
            // Ensure the correct URL structure remains
            const url = new URL(window.location.href);
            url.search = ""; // Remove query parameters
            window.location.href = url.toString();
        } else {
            setErrors({});
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        }
    };

    const saveDonation = async (body: DonationBody) => {
        onClick(false);
        dispatch(showLoader());
        try {
            const { data } = await createDonation(body, APICallerRef.current);
            window.location.href = data;
        } catch (error: any) {
            setNotification({ ...notification, isOpen: true, message: error.message, type: "error" });
        } finally {
            dispatch(hideLoader());
        }
    };

    const [scrolling, setScrolling] = useState(false);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        const handleScroll = () => {
            setScrolling(true);

            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            timeoutRef.current = setTimeout(() => {
                setScrolling(false);
            }, 1000); // ? ??????? ?? scrollbar ??????
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return (
        <>
            <donorInfoContext.Provider
                value={{
                    donorName,
                    setDonorName,
                    donorEmail,
                    setDonorEmail,
                    donorPhoneNumber, // Add donorPhoneNumber here
                    setDonorPhoneNumber, // Add setDonorPhoneNumber here
                    donorAddress,
                    setDonorAddress,
                    donorCity,
                    setDonorCity,
                    donorState,
                    setDonorState,
                    donorCountry,
                    setDonorCountry,
                    donorZipCode,
                    setDonorZipCode,
                    isAnnonymous,
                    setIsannonymous,
                    isAgreed,
                    setIsagreed,
                    isOrganization,
                    setIsOrganization,
                    organizationName,
                    setOrganizationName,
                }}
            >
                {showDialog && (
                    <Box
                        display="flex"
                        flexDirection={{ xs: "column", md: "row" }} // Responsive flex direction
                        gap={{ xs: 0, md: 2 }} // No gap on mobile, gap on larger screens
                        sx={{
                            position: "fixed",
                            zIndex: 1000,
                            top: 0,
                            left: 0,
                            right: 0,
                            height: "100vh",
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                            justifyContent: "center",
                            alignItems: "center",
                            // padding: 2,
                            overflowY: "auto",
                            "@media (max-width: 960px)": {
                                backgroundColor: "#fff",
                            },
                        }}
                    >
                 

                        {/* Dialog Content - Two boxes with responsive margins */}
                        <Box>
                            {activeStep === stepsLabel.length ? (
                                <Box>
                                    <DonationSuccessPage isSuccessful={isDonationSuccessful} isOfflineDonation={isOfflineDonation} />
                                </Box>
                            ) : (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: { xs: "column", md: "row" },
                                        width: { xs: "99%", sm: "98%", md: "98%" },
                                        maxWidth: "1200px", // Optional: Limit max width
                                        margin: "0 auto", // Center the main box horizontally
                                        // padding: 2,
                                        // backgroundColor: "#fff",
                                        maxHeight: "100vh",
                                        overflowY: "auto",
                                        overflowX: "hidden",
                                        scrollBehavior: "smooth",

                                        /* ? Scrollbar ?????? */
                                        "&::-webkit-scrollbar": {
                                            width: scrolling ? "6px" : "0px",
                                            visibility: scrolling ? "visible" : "hidden",
                                            transition: "width 0.3s ease, visibility 0.3s ease",
                                        },
                                        "&::-webkit-scrollbar-track": {
                                            backgroundColor: "transparent",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            backgroundColor: "#888",
                                            borderRadius: "10px",
                                        },
                                        "&::-webkit-scrollbar-thumb:hover": {
                                            backgroundColor: "#555",
                                        },
                                        // "@media (max-width: 992px)": {
                                        //     justifyContent: "start",
                                        //     alignItems: "start",
                                        // },

                                        "@media (max-width: 992px)": {
                                            justifyContent: "start", // Center content horizontally
                                            alignItems: "start", // Center content vertically
                                        },
                                    }}
                                >
                                    {activeStep == 0 && (
                                        <Box
                                            sx={{
                                                width: "550px",
                                                borderRadius: 1.5,
                                                // height: "600px",
                                                backgroundColor: "#fff",
                                                // flex: 1,
                                                marginLeft: { lg: 1, md: 1, xs: 0 },
                                                marginRight: { lg: 1, md: 1, xs: 0 },
                                                pb: 2,
                                                "@media (max-width: 768px)": {
                                                    width: "95%",
                                                    borderRadius: 0,
                                                    // borderRadius: 0,
                                                    mx: "auto",
                                                },
                                                "@media (min-width: 769px) and (max-width: 991px)": {
                                                    width: "100%",
                                                    // Example width for the range
                                                    // marginLeft: "auto",
                                                    // marginRight: "auto",
                                                    borderBottomLeftRadius: 0,
                                                    borderBottomRightRadius: 0,
                                                },
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: "100%",
                                                    display: "flex",
                                                    borderRadius: 1.5,
                                                    // justifyContent: "center",
                                                    py: 1,
                                                    "@media (min-width: 992px)": {
                                                        justifyContent: "center",
                                                        py: 0,
                                                    },
                                                }}
                                            >
                                                {slug !== "stand-with-our-friend-imtiaz" && (
                                                    <Box
                                                        sx={{
                                                            "@media (max-width: 480px)": {
                                                                // height: "70%", // Removes padding on larger screens
                                                                width: "120px",
                                                                px: 0,
                                                            },
                                                            px: 2,
                                                            // height: "45px",
                                                            width: "150px",
                                                            "@media (min-width: 992px)": {
                                                                display: "none",
                                                            },
                                                        }}
                                                    >
                                                            <a href="https://thals.org/" target="_blank" rel="noopener noreferrer">
                                                                <img
                                                                    src={`${process.env.PUBLIC_URL}/static/images/logo/BTF-Logo-TransparentUse.png`}
                                                                    alt="Thals-logo"
                                                                    style={{ width: "100%" }}
                                                                />
                                                            </a>
                                                    </Box>
                                                )}
                                            </Box>

                                            <Box
                                                textAlign={"left"}
                                                mb={4}
                                                mt={slug === "stand-with-our-friend-imtiaz" ? 4 : 0} // Add mt={4} conditionally
                                                sx={{
                                                    width: "100%",
                                                    borderRadius: 8,
                                                    backgroundColor: "#fff",

                                                    "@media (max-width: 768px)": {
                                                        borderRadius: 0,
                                                    },
                                                    "@media (min-width: 769px) and (max-width: 992px)": {
                                                        width: "100%",
                                                        borderBottomLeftRadius: 0,
                                                        borderBottomRightRadius: 0,
                                                    },
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        borderTopLeftRadius: "15px",
                                                        borderTopRightRadius: "15px",
                                                    }}
                                                >
                                                    <img
                                                        src={ImageUrl}
                                                        alt="Payment Info"
                                                        style={{
                                                            width: "100%", // Make the image responsive to container width
                                                            marginBottom: "10px",
                                                            borderTopLeftRadius: isMobile ? "0px" : "15px",
                                                            borderTopRightRadius: isMobile ? "0px" : "15px",
                                                        }}
                                                    />
                                                </Box>
                                                <Box
                                                    sx={{
                                                        width: "100%",
                                                        px: 2,
                                                        display: "none",
                                                        // height: "45px",

                                                        "@media (min-width: 992px)": {
                                                            display: "flex",
                                                            justifyContent: "center",
                                                        },
                                                    }}
                                                >
                                                    {slug !== "stand-with-our-friend-imtiaz" && (
                                                        <Box
                                                            sx={{
                                                                "@media (max-width: 480px)": {
                                                                    // height: "70%", // Removes padding on larger screens
                                                                    width: "120px",
                                                                    px: 0,
                                                                },
                                                                px: 2,
                                                                display: "none",
                                                                // height: "45px",
                                                                width: "150px",
                                                                "@media (min-width: 992px)": {
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                },
                                                            }}

                                                        >
                                                                <a href="https://thals.org/" target="_blank" rel="noopener noreferrer">
                                                                     <img
                                                                        src={`${process.env.PUBLIC_URL}/static/images/logo/BTF-Logo-TransparentUse.png`}
                                                                        alt="Thals-logo"
                                                                        style={{ width: "100%" }}
                                                                    />
                                                                </a>
                                                        </Box>
                                                    )}
                                                </Box>

                                                <Typography
                                                    sx={{
                                                        fontSize: smallerScreens ? "14px" : "15px",
                                                        textAlign: "justify",
                                                        px: 0.5,
                                                        py: 1,
                                                        "@media (min-width: 992px)": {
                                                            px: 2,
                                                            lineHeight: "30px",
                                                        },
                                                    }}
                                                    fontSize={20}
                                                    lineHeight={"20px"}
                                                    fontWeight={400}
                                                    color={"#223354"}
                                                    fontFamily={"Outfit, ui-sans-serif, system-ui"}
                                                >
                                                    {parse(`<h2>${title}</h2>`)}
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        borderRadius: "8px",
                                                        whiteSpace: "pre-wrap", // Preserve line breaks
                                                        wordWrap: "break-word",
                                                        fontSize: smallerScreens ? "14px" : "15px",
                                                        fontFamily: "Outfit, ui-sans-serif, system-ui",
                                                        color: "#616D79 !important",
                                                        lineHeight: 1.6,
                                                        textAlign: "justify",

                                                        "@media (min-width: 992px)": {
                                                            px: 2,
                                                            lineHeight: "30px",
                                                        },
                                                    }}
                                                    fontSize={20}
                                                    textAlign={"justify"}
                                                    lineHeight={"24px"}
                                                    fontWeight={400}
                                                    color={"#616D79"}
                                                    fontFamily={"Outfit, ui-sans-serif, system-ui"}
                                                >
                                                    {/* {parse(`<span style="color: #616D79 !important;">${description}</span>`)} */}
                                                    <span dangerouslySetInnerHTML={{ __html: description }} />
                                                </Typography>
                                            </Box>

                                            {/* <Box>
                                                <Box sx={{   textAlign: "center", mt: 2 }}>
                                        
                                                    <Typography sx={{ fontSize: "14px", mt: 1, color: "#616D79" }}>
                                                        <Link to={"#"} style={{ textDecoration: "none", color: "#223354", marginRight: "10px" }}>
                                                            Terms & Conditions
                                                        </Link>
                                                        |
                                                        <Link to={"#"} style={{ textDecoration: "none", color: "#223354", marginLeft: "10px" }}>
                                                            Privacy Policy
                                                        </Link>
                                                    </Typography>
                                                </Box>
                                            </Box> */}
                                            <Box sx={{ display: { md: "none" } }}>
                                                <Divider></Divider>
                                            </Box>
                                        </Box>
                                    )}
                                    <Box
                                        sx={{
                                            width: "450px",
                                            height: "100%",
                                            borderTopRightRadius: "12px",
                                            borderTopLeftRadius: "12px",
                                            backgroundColor: "#fff",
                                            //  boxShadow: "rgba(100, 100, 111, 0.8) 0px 0px 29px 7px",

                                            marginLeft: { lg: 1, md: 1, xs: 0 },
                                            marginRight: { lg: 1, md: 1, xs: 0 },
                                            textAlign: "left",

                                            // Responsive styles

                                            "@media (min-width: 992px)": {
                                                px: 2,
                                                pt: 1.5,
                                                borderRadius: "12px",
                                            },
                                            "@media (max-width:768px)": {
                                                width: "100%",
                                                borderTopLeftRadius: 0,
                                                borderTopRightRadius: 0,
                                                marginX: "auto", // marginLeft & marginRight ??????
                                            },
                                            "@media (max-width:575px)": {
                                                width: "100%",
                                                height: "auto",
                                                borderTopLeftRadius: 0,
                                                borderTopRightRadius: 0,
                                            },
                                            "@media (min-width:769px) and (max-width:992px)": {
                                                width: "95%",
                                                borderTopLeftRadius: 0,
                                                borderTopRightRadius: 0,
                                                px: 2,
                                            },
                                        }}
                                    >
                                        <Box>
                                            {/* {activeStep === stepsLabel.length ? (
                                                <Box>
                                                    <DonationSuccessPage isSuccessful={isDonationSuccessful} isOfflineDonation={isOfflineDonation} />
                                                </Box>
                                            ) : ( */}
                                            <Box>
                                                <selectedOptionsContext.Provider
                                                    value={{
                                                        selectedPatient,
                                                        setSelectedPatient,
                                                        selectedInstrument,
                                                        setSelectedInstrument,
                                                        selectedResearch,
                                                        setSelectedResearch,
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            width: "100%",
                                                            mx: "auto", // This centers the Box horizontally
                                                            // px: 2,
                                                            backgroundColor: "#fff",
                                                            "@media (max-width: 768px)": {
                                                                width: "95%",
                                                                borderRadius: 0,
                                                                // borderRadius: 0,
                                                                mx: "auto",
                                                            },
                                                        }}
                                                    >
                                                        {stepsContent[activeStep]}
                                                    </Box>
                                                </selectedOptionsContext.Provider>
                                            </Box>
                                            {/* )} */}
                                            <Box
                                                marginY={1.5}
                                                sx={{
                                                    borderBottomRightRadius: "12px !important", //
                                                    borderBottomLeftRadius: "12px !important",
                                                    backgroundColor: "#fff",
                                                    //    marginBottom:"50px"
                                                }}
                                                textAlign={"center"}
                                                width={"100%"}
                                                height={"100%"}
                                            >
                                                <Box
                                                    textAlign="center"
                                                    pb={2}
                                                    px={0.5}
                                                    sx={{
                                                        backgroundColor: "#fff",
                                                        mb: { xs: 2, sm: 4 },
                                                    }}
                                                    // display="flex"
                                                    // alignItems="center" // Vertical alignment
                                                    // justifyContent="center" // Horizontal alignment
                                                    // flexDirection={"row"}
                                                    gap={2} // Space between the buttons
                                                >
                                                    {activeStep !== stepsLabel.length && (
                                                        <ShadowedButton
                                                            onClick={() => {
                                                                handleNext();
                                                                handleDonationInitiated();
                                                            }}
                                                            color="error"
                                                            disabled={
                                                                isSubmitButtonDisabled ||
                                                                (activeStep === stepsLabel.length - 2 &&
                                                                    (donationAmount === "" ||
                                                                        donationCurrency === "" ||
                                                                        donationType === "" ||
                                                                        paymentType === "" ||
                                                                        invalidAmount))
                                                            }
                                                            sx={{
                                                                // mr: 2,
                                                                mt: { xs: 2, sm: 0 },

                                                                px: "20px",
                                                                width: "100%",
                                                                backgroundColor: "#ce1337", // Background color for enabled state
                                                                color: "#fff", // Text color for enabled state
                                                                border: "1px solid #ce1337", // Border color for enabled state
                                                                "&:hover": {
                                                                    backgroundColor: "#b0112f", // Optional: Darker shade on hover
                                                                    borderColor: "#b0112f",
                                                                },
                                                                "&.Mui-disabled": {
                                                                    border: "1px solid #acacac",
                                                                    color: "#acacac",
                                                                    backgroundColor: "transparent",
                                                                },
                                                            }}
                                                            fullWidth={smallerScreens}
                                                        >
                                                            {activeStep === stepsLabel.length - 1 ? "Proceed to Payment" : "Next"}
                                                        </ShadowedButton>
                                                    )}
                                                    {activeStep !== 0 && !isDonationSuccessful && !isOfflineDonation && (
                                                        <Button
                                                            variant="outlined"
                                                            color="secondary"
                                                            onClick={handleBack}
                                                            fullWidth={smallerScreens}
                                                            sx={{
                                                                mt: { xs: 2, sm: 2 },
                                                                width: "100%",
                                                                backgroundColor: "#fff",
                                                                color: "#ce1337",
                                                                borderColor: "#ce1337",
                                                                "&:hover": {
                                                                    boxShadow: `0 5px 10px rgba(206, 19, 55, 0.1)`,
                                                                    borderColor: "#ce1337",
                                                                    color: "#ce1337",
                                                                },
                                                            }}
                                                        >
                                                            Go Back
                                                        </Button>
                                                    )}
                                                    <Box
                                                        sx={{
                                                            height: "50px",
                                                            backgroundColor: "#fff",
                                                        }}
                                                    ></Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            )}
                        </Box>
                    </Box>
                )}
                <Notification notification={notification} setNotification={setNotification} />
            </donorInfoContext.Provider>
        </>
    );
};

export default HorizontalLinearStepper;
